import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from "@angular/forms";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { VolumeCalculatorComponent } from "../../form-parts/volume-calculator/volume-calculator.component";
import { FormService } from "../../services/form.service";
import { ApiService } from "../../services/api.service";

@Component({
    selector: 'app-moving-content',
    templateUrl: './moving-content.component.html',
    styleUrls: ['./moving-content.component.scss']
})
export class MovingContentComponent implements OnInit {

    movingContent !: UntypedFormGroup
	formGroupName : string = 'movingContent'
	vcPreCategories: any | undefined;

    constructor( private dialog: MatDialog,
                 public formService: FormService,
                 private apiService: ApiService ) { }

    public ngOnInit(): void {

        this.movingContent = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;
	    this.getVcItems();
    }

    ngAfterViewInit() {

        // After view has loaded
    }

    public onSubmit() {

        this.formService.submitFormGroup( (<UntypedFormGroup>this.movingContent) );
    }

    public openVolumeCalculator() {

        const dialogConfig = new MatDialogConfig();
		dialogConfig.height = 'calc( 100vh - 55px )';
		dialogConfig.width = '920px';
		dialogConfig.backdropClass = 'vc-blurred-bg';
		dialogConfig.panelClass = 'vc-dialog';

		// Pass data
		dialogConfig.data = { vcCategories: this.formService.vcCategories, vcPreCategories: this.vcPreCategories };

	    this.dialog.open(VolumeCalculatorComponent, dialogConfig );
    }

	public hasVolume() {

		return this.movingContent.controls['volumeM3'].value > 0;
	}

	public getMovingSize() {

		return Number( (<UntypedFormGroup>this.formService.mainForm.get( 'movingSize' ) ).controls['movingSize'].value );
	}

	public getVolumeText() : string {

		var output = '';

		for( var item of this.formService.getVolumeOrder() ) {

			if( item === 'm3' ) {

				output += this.movingContent.controls['volumeM3'].value + 'm³';
			}

			if( item === 'divider' ) {

				output += ' / ';
			}

			if( item === 'ft3' ) {

				output += this.movingContent.controls['volumeFt3'].value + 'ft³';
			}
		}

		return output;
	}

	public async getVcItems() {

		this.apiService.getVcItems().subscribe( response => {

			this.formService.vcCategories = response;
			this.formService.setupVolumeCalculatorForm( response );
		} );

		// If there's a vc token
		var token = (<UntypedFormGroup>this.formService.mainForm).controls['_vcToken'].value;

		if( token.length > 0 ) {

			this.apiService.getVcPreItems( token ).subscribe( (response: any) => {

				if( response ) {

					// Prepare for vc
					this.vcPreCategories = response.vc;

					// Pre-set movingSize
					var movingSizeControl = (<UntypedFormGroup>this.formService.mainForm.controls['movingSize']).controls['movingSize'];

					// If the pre-set volume is more than 0
					if( response.m3 > 0 ) {

						if( response.m3 <= 4 ) {

							movingSizeControl.setValue( 3 );
						}
						else if( response.m3 <= 12 ) {

							movingSizeControl.setValue( 2 );
						}
						else {

							movingSizeControl.setValue( 1 );
						}

						// Set ft3 and m3 from email
						this.movingContent.controls['volumeM3'].setValue( response.m3 );
						this.movingContent.controls['volumeFt3'].setValue( response.ft3 );
					}
				}
			} );
		}
	}
}